import { render, staticRenderFns } from "./DotLabel.vue?vue&type=template&id=60fd33fd&scoped=true&"
import script from "./DotLabel.vue?vue&type=script&lang=js&"
export * from "./DotLabel.vue?vue&type=script&lang=js&"
import style0 from "./DotLabel.vue?vue&type=style&index=0&id=60fd33fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fd33fd",
  null
  
)

export default component.exports